import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, r1, r2, r5, sImaginary) {
  var result = Complex.createComplex(r1 * r2 + r1 * r5 + r2 * r5, c1 * r1 * r2 * r5 * sImaginary).divide(
    complexDenominator,
  );
  return result;
}

export function computeComplexFF(complexFFDenominator, c1, c2, r1, r2, r5, rOut, sImaginary, sSquared) {
  var complexFFNumerator = Complex.createComplex(
    rOut * r1 + sSquared * rOut * c1 * c2 * r1 * r2 * r5,
    sImaginary * rOut * (c2 * r1 * r2 + c2 * r1 * r5 + c2 * r2 * r5),
  );
  var result = complexFFNumerator.divide(complexFFDenominator);
  return result;
}
